<template>
  <div class="seo-progress" :title="hint">
    <div class="seo-progress__track"><div class="seo-progress__bar" :style="{ width: barWidth + '%', background: barColor }" /></div>
    <span class="seo-progress__count" :style="{ color: barColor }">{{ fa(len) }} / {{ fa(max_perfect) }}</span>
    <span class="seo-progress__hint">{{ hint }}</span>
  </div>
</template>

<script>
const FA = '۰۱۲۳۴۵۶۷۸۹'

/** Character counter with a coloured bar: yellow = too short, green = ideal range, red = too long. */
export default {
  name: 'SeoProgress',
  props: {
    string: { type: String, default: '' },
    min_perfect: { type: Number, default: 0 },
    max_perfect: { type: Number, default: 0 },
  },
  computed: {
    len() { return String(this.string || '').length },
    barWidth() { return this.max_perfect ? Math.min(100, (this.len * 100) / this.max_perfect) : 0 },
    barColor() {
      if (!this.len || this.len < this.min_perfect) return '#d97706'
      if (this.len <= this.max_perfect) return '#059669'
      return '#dc2626'
    },
    hint() {
      if (!this.len) return 'خالی'
      if (this.len < this.min_perfect) return 'کوتاه است (پیشنهاد: ' + this.fa(this.min_perfect) + ' تا ' + this.fa(this.max_perfect) + ' نویسه)'
      if (this.len <= this.max_perfect) return 'مناسب'
      return 'طولانی است (' + this.fa(this.len - this.max_perfect) + ' نویسه بیشتر)'
    },
  },
  methods: {
    fa(n) { return String(n).replace(/\d/g, (d) => FA[d]) },
  },
}
</script>

<style scoped>
.seo-progress { display: flex; align-items: center; gap: 8px; margin-top: 6px; font-size: 12px; direction: rtl; }
.seo-progress__track { flex: 1; height: 4px; border-radius: 4px; background: #e5e7eb; overflow: hidden; }
.seo-progress__bar { height: 100%; border-radius: 4px; transition: width .15s, background .15s; }
.seo-progress__count { min-width: 56px; font-weight: 600; text-align: left; direction: ltr; unicode-bidi: plaintext; }
.seo-progress__hint { min-width: 90px; color: #6b7280; font-size: 11px; }
</style>
